// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"edit_buttonContainer__3wEs8","saveButton":"edit_saveButton__3Dkl4"};